module.exports = __webpack_public_path__ + "img/pn.7d49d6f9.svg";